const Footer = () => (
  <footer>
    <p>I'm the footer</p>
  </footer>
)

export default Footer
